import { Alert, Button } from '@src/controls';
import { useFormatMessage } from '@src/i18n';
import { useSiteId } from '@src/utils/hooks';
import React from 'react';

type Props = {
  link: string;
};

export const excludedSiteIds = [
  // Production
  'f63024e08ffb42258b812c0beb8de531', // Apoteket
  '89407e8f4de744e6a113e692c197ec96', // Apotek Hjärtat
  '68e40cfae5404d4ea1a2755d947e4fc1', // Acme AB
  '4dfa964b-7718-4478-a5ee-745de0d5b06c', // Desenio
  '7495f7b2-4b02-4615-ad57-0041d9c05210', // Desenio CZ Warehouse
  'a1d96c29-1fa6-4346-a19f-124071140756', // Poster Store
  'a41a0aa2-08ef-46c6-9afb-c2b8df9db2d6', // Poster Store CZ Warehouse

  '8afc7848-5dc2-4384-9c22-1d714daef25b', // Dyrekassen
  '73fce7df-7579-4175-96b1-ba2d37bb3675', // PetXL
  'aedb8393-c2f6-4f52-b4f6-896db37d9309', // PetXL Stores
  '8a03326d-5ada-4bc5-aaa9-95e81d6678db', // Pritax AB
  '583635f1-dc8e-4398-9a04-66bc89ff8b88', // Tinybuddy
  '7d3eec67-5c8e-4317-b154-9dc8f1a9fa85', // Zoo.se
  'f9f71db5-93e5-41b1-b65a-745a68bf9607', // Zoo.se FI

  // Stage
  'f63024e08ffb42258b812c0beb8de531', // Apoteket AB (AT - Acceptance Test)
  'a2b95da5138e4ad9bede915af09aa78d', // Apoteket AB (SIT - System Integration Test)
  '89407e8f4de744e6a113e692c197ec96', // Apotek Hjärtat
  '68e40cfae5404d4ea1a2755d947e4fc1', // Acme AB
  'b0807686-e848-462d-ad0f-440ebc72ce6b', // Desenio
  '47f328ad-7120-4498-9046-0ed269565e2b', // Desenio CZ
  '996d1c79-d077-482d-a3d9-0f8b464767cf', // Poster Store
  '62757c5e-7d9b-4d5a-841e-18078cb40010', // Poster Store CZ

  // Dev
  'f63024e08ffb42258b812c0beb8de531', // Apoteket AB (AT - Acceptance Test)
  '1cc74289-9418-4d75-960e-f04d8cc6ef6a', // Apotek Hjärtat
  '68e40cfae5404d4ea1a2755d947e4fc1', // Acme AB
];

export function NewExperienceAlert({ link }: Props) {
  const formatMessage = useFormatMessage();
  const siteId = useSiteId();

  if (!siteId) {
    return null;
  }

  return (
    <Alert
      description={
        excludedSiteIds.includes(siteId)
          ? formatMessage('NEW_EXPERIENCE_ALERT_DESC')
          : formatMessage('NEW_EXPERIENCE_ALERT_DESC_DEP')
      }
      message={formatMessage('NEW_EXPERIENCE_ALERT_TITLE')}
      action={
        <a href={link}>
          <Button type="default" htmlType="button">
            {formatMessage('NEW_EXPERIENCE_ALERT_CTA')}
          </Button>
        </a>
      }
      style={{ marginBottom: '24px' }}
      type="info"
    />
  );
}
